<div class="download-csv" *ngIf="!importedFileName && canDownloadCSV && totalCount > 0">
  <button class="btn btn-outline-secondary" [hidden]="downloading" (click)="downloadWithPermission()">
    <img src="/assets/images/icon-16-download.svg" alt="Download Icon" />
    Download as CSV
  </button>
  <div [hidden]="!downloading" class="loading-icon" data-loader="circle-side"></div>
</div>
<div class="download-csv" *ngIf="importedFileName">
  <div class="dropdown filter-dropdown import-csv-dropdown" [hidden]="downloading || !downloadColumns">
    <button id="download-csv-dropdown" class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <img src="/assets/images/icon-16-download.svg" alt="Download Icon" /> Download as CSV
    </button>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
      <div class="select-all-cont">
        <a class="dropdown-item" (click)="toggleSelectAllColumns($event)" [ngClass]="{selected: selectAllColumns}">
          <i class="fa fa-check-square-o"></i>
          <i class="fa fa-square-o"></i>&nbsp;Select all
        </a>
      </div>
      <div class="dropdown-menu-list-cont">
        <a class="dropdown-item" (click)="toggleDownloadColumn($event, column)" [ngClass]="{selected: column.selected}"
          *ngFor="let column of downloadColumns">
          <i class="fa fa-check-square-o"></i>
          <i class="fa fa-square-o"></i> {{column.label}}
        </a>
      </div>
      <div class="download-cont">
        <a class="btn btn-link">Cancel</a>

        <button class="btn btn-primary btn-dropdown" [ngClass]="{disabled: downloadButtonDisabled}"
          (click)="$event.stopPropagation();">
          Download <i class="fa fa-caret-down"></i>
          <div class="menu-list">
            <a class="menu-item" (click)="downloadCsvWithColumns($event)">Filtered</a>
            <a class="menu-item" data-toggle="tooltip" title="Downloads all combinations"
              *ngIf="!hideUnfilteredDownloadCsv" (click)="downloadCsvWithColumns($event, true)">Unfiltered</a>
          </div>
        </button>

      </div>
    </div>
  </div>
  <div [hidden]="!downloading" class="loading-icon" data-loader="circle-side"></div>
</div>